var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('code',[_c('span',[(!_vm.noUrl)?_c('a',{attrs:{"href":_vm.url}},[_c('span',{class:_vm.codeColor},[_vm._v("["+_vm._s(_vm.metaRel)+"]")])]):_c('a',[_c('span',{class:_vm.codeColor},[_vm._v("["+_vm._s(_vm.metaRel)+"]")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }